import {
  CANCEL_FUELING_PROCESS,
  CANCEL_FUELING_PROCESS_FAILED,
  HIDE_FUELING_PROCESS_CANCEL_EDIT,
  SHOW_FUELING_PROCESS_CANCEL_EDIT,
} from "./constants";

export interface ShowFuelingProcessCancelEditAction {
  type: typeof SHOW_FUELING_PROCESS_CANCEL_EDIT;
  fuelingProcessId: string;
}

export function showFuelingProcessCancelEdit(
  fuelingProcessId: string
): ShowFuelingProcessCancelEditAction {
  return {
    type: SHOW_FUELING_PROCESS_CANCEL_EDIT,
    fuelingProcessId: fuelingProcessId,
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function hideFuelingProcessCancelEdit() {
  return {
    type: HIDE_FUELING_PROCESS_CANCEL_EDIT,
  };
}

export interface CancelFuelingProcessAction {
  type: typeof CANCEL_FUELING_PROCESS;
  fuelingProcessId: string;
  description: string;
}

export function cancelFuelingProcess(
  fuelingProcessId: string,
  description: string
): CancelFuelingProcessAction {
  return {
    type: CANCEL_FUELING_PROCESS,
    fuelingProcessId: fuelingProcessId,
    description: description,
  };
}

export interface CancelFuelingProcessFailedAction {
  type: typeof CANCEL_FUELING_PROCESS_FAILED;
  errorCode: string;
  errorMessage: string;
}

export function cancelFuelingProcessFailed(
  errorCode: string,
  errorMessage: string
): CancelFuelingProcessFailedAction {
  return {
    type: CANCEL_FUELING_PROCESS_FAILED,
    errorCode: errorCode,
    errorMessage: errorMessage,
  };
}
